import cn from "classnames";
import { IntrinsicElements } from "types/intrinsicElements.types";
import styles from "./Input.module.scss";

export type InputProps = IntrinsicElements["input"] & {
  label?: string;
  errorMessage?: string;
  renderIcon?: JSX.Element;
  labelClassName?: string;
  labelTextClassName?: string;
  errorMessageClassName?: string;
  error?: boolean;
  placeholder?: string;
  embedded?: boolean;
};

export const Input = ({
  label,
  className,
  disabled,
  errorMessage,
  renderIcon,
  labelClassName,
  labelTextClassName,
  errorMessageClassName,
  embedded,
  error,
  placeholder,
  ...props
}: InputProps) => {
  return (
    <label aria-label="input-wrapper" className={cn(styles.label, labelClassName)}>
      {label && (
        <div
          aria-label="label"
          className={cn(styles.labelText, { [styles.labelTextDisabled]: disabled }, labelTextClassName)}
        >
          {label}
        </div>
      )}
      {renderIcon && (
        <div aria-label="icon-wrapper" className={styles.renderIcon}>
          {renderIcon}
        </div>
      )}
      <input
        className={cn(
          className,
          styles.input,
          { [styles.inputError]: error },
          { [styles.inputDisabled]: disabled },
          { [styles.inputRenderIcon]: renderIcon },
          { [styles.inputEmbedded]: embedded }
        )}
        disabled={disabled}
        placeholder={placeholder}
        {...props}
      />
      {errorMessage && (
        <span aria-label="error-message" className={cn(styles.errorMessage, errorMessageClassName)}>
          {errorMessage}
        </span>
      )}
    </label>
  );
};
